export enum PriceType {
  Fixed = 1,
  Free = 2,
  Interval = 3,
}
